import type { FC } from "react";

import { CustomCheckbox, CustomLabel } from "@/components/atoms";
import { FormControl, FormItem } from "@/components/ui/form";

export interface Option {
  id: string;
  name: string;
  exclusive?: boolean;
}

interface BaseSelectOptionsProps {
  selectList: Option[];
  selected: string[];
  onChange: (next: string[]) => void;
  disabled?: boolean;
}

const BaseSelectOptions: FC<BaseSelectOptionsProps> = ({
  selectList,
  selected,
  onChange,
  disabled,
}) => (
  <div className="flex flex-col gap-3">
    {selectList.map(({ id, name }) => (
      <FormItem key={id} className="flex items-center gap-2">
        <FormControl>
          <CustomCheckbox
            id={id}
            checked={selected.includes(id)}
            onCheckedChange={checked => {
              const nextValue = checked
                ? [...selected, id]
                : selected.filter(v => v !== id);
              onChange(nextValue);
            }}
            data-testid={`base-select-checkbox-${id}`}
            disabled={disabled}
          />
        </FormControl>
        <CustomLabel htmlFor={id} label={name} />
      </FormItem>
    ))}
  </div>
);

export default BaseSelectOptions;
